import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

export default function UnsavedChangesDialog({ open, onSave, onDiscard, onCancel }) {
    return (
        <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
            <DialogTitle>Unsaved Changes</DialogTitle>
            <DialogContent>
                <Typography gutterBottom>
                    You have unsaved changes. Do you want to save before leaving this tab?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onDiscard} color="error">Discard</Button>
                <Button onClick={onCancel} color="inherit">Cancel</Button>
                <Button onClick={onSave} color="primary" variant="contained">Save</Button>
            </DialogActions>
        </Dialog>
    );
}
